export default __webpack_public_path__ + "media/images/so_sad-1763b82aa645cec33cfc6bfbf5cf3320.png";